/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            minWidth: 'xs',
            width: 'full',
            backgroundColor: 'white',
            transition: 'all 0.2s ease-in-out'
        },
        content: {
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingLeft: [1, 1, 10],
            paddingRight: [4, 4, 6],
            py: [7, 7, 1]
        },
        searchContainer: {
            order: [2, 2, 2, 'inherit'],
            width: 'full'
        },
        bodyContainer: {
            flex: '1'
        },
        links: {
            display: 'inline-block',
            textTransform: 'uppercase',
            p: ['6px', null, '14px'],
            fontSize: 'xs',
            lineHeight: 'shorter',
            letterSpacing: '0.06em',
            textDecoration: 'none'
        },
        logo: {
            width: '94px',
            height: 'auto'
        },
        accountIcon: {
            height: 11,
            minWidth: 'auto',
            cursor: 'pointer',
            alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            }
        },
        arrowDown: {
            height: 11,
            minWidth: 'auto',
            marginRight: 0,
            alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
            cursor: 'pointer',
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            },
            display: ['none', 'none', 'none', 'block']
        },
        wishlistIcon: {
            // More breathing room between the account and wishlist icons
            marginLeft: 2
        },
        signout: {
            width: '100%',
            borderRadius: '4px',
            height: 11,
            padding: 4,
            py: 3,
            marginTop: 1,
            _hover: {
                background: 'gray.50'
            }
        },
        signoutText: {
            fontSize: 'sm',
            fontWeight: 'normal'
        },
        signoutIcon: {
            marginRight: 2
        }
    },
    variants: {
        transparentDark: {
            container: {
                backgroundColor: 'transparent',
                position: 'absolute'
            }
        },
        transparentLight: {
            container: {
                backgroundColor: 'transparent',
                position: 'absolute'
            },
            icons: {
                color: 'white'
            },
            links: {
                color: 'white'
            }
        },
        basicAbsolute: {
            container: {
                position: 'absolute'
            }
        }
    },
    parts: [
        'container',
        'content',
        'searchContainer',
        'bodyContainer',
        'logo',
        'icons',
        'links',
        'signout'
    ]
}
